import { getCareItemAnimationName } from 'src/lib/ui/config/buruburu';
import { CareItem, careItems } from 'src/replicant/care/care.ruleset';
import { CareItemEntity, fromEntityId } from '../logic/EntityManager';

export class ItemAppearanceController {
  constructor(private entity: CareItemEntity) {}

  public async animate() {
    const fromEntity = fromEntityId(this.entity.entityId);
    const id = fromEntity.id as CareItem['id'];

    const { item } = careItems[id];
    await this.entity.playAsync(getCareItemAnimationName(item));

    // Stop item on the last animation frame
    this.entity.goto(this.entity.frameCount - 1);
  }
}
